import Modal from "@mui/material/Modal";
import { Box, Grid } from "@mui/material";
import styles from "./SessionClassTimeoutModal.module.css";
import Button from "@mui/material/Button";
import handsPhone from "../../Assets/fr-HandsPhone.svg";
import { useNavigate } from "react-router-dom";
import { useCognitoAwsV2 } from "../../Hooks/useCognitoAwsv2";

interface Props {
  open: boolean;
  seconds: number;
  handleClose: () => void;
}

const SessionClassTimeoutModal = ({ open, seconds, handleClose }: Props) => {
  const navigate = useNavigate();
  const { signOut } = useCognitoAwsV2();

  const onLogout = async () => {
    await signOut();
    handleClose();
    navigate("/");
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="session-expired-title"
      aria-describedby="session-expired-description"
    >
      <Box className={styles.modal}>
        <Grid>
          <p className={styles.modalTitle}>Details Page expired</p>
          <p className={styles.modalSubtitle}>
            The information shown on this page will expire in
          </p>
          <p className={styles.seconds}>{seconds}</p>
          <img
            className={styles.image}
            src={handsPhone}
            width={131}
            height={113}
            alt="Session Expired"
          />
          <p className={styles.modalSubtitle}>
            To continue viewing this page please Stay Signed in
          </p>
        </Grid>
        <Grid>
          <Button
            className={styles.modalButtons}
            variant="contained"
            onClick={onLogout}
          >
            Log out
          </Button>
          <Button
            variant="contained"
            className={styles.modalButtons}
            onClick={handleClose}
          >
            Stay Signed in
          </Button>
        </Grid>
      </Box>
    </Modal>
  );
};

export default SessionClassTimeoutModal;
